import axios from 'axios'

import environment from '@/environment'
import type { ActivationSchedulesByRegulationObject } from '@/features/activationPlan/types'

const PORTFOLIO_MANAGER_API_URL = environment.services.portfolioManagerApiUrl

export const GET_ACTIVATION_SCHEDULES_BY_REGULATION_OBJECT_API_ID = 'GET_ACTIVATION_SCHEDULES_BY_REGULATION_OBJECT'

export interface GetActivationSchedulesByRegulationObjectParams {
  portfolioCode: string
  deliveryDay: string
}

export const getActivationSchedulesByRegulationObject = async (
  params: GetActivationSchedulesByRegulationObjectParams,
): Promise<ActivationSchedulesByRegulationObject> => {
  const urlParams = new URLSearchParams()
  urlParams.append('portfolioCode', params.portfolioCode)
  urlParams.append('deliveryDay', params.deliveryDay)
  return (
    await axios.get(`${PORTFOLIO_MANAGER_API_URL}/activation-schedule/by-regulation-object`, { params: urlParams })
  ).data
}
